import axios from "axios";
import {apiConfig} from "@/config";

export default class DepService {
    static async doiOne() {

    }

    static async subscriptionCallerTone(msisdn, subscriptionId, serviceId, toneId) {
        const response = await axios.post(`${apiConfig.depService}/upsell/caller-tone-subscribe`, {
                msisdn: msisdn,
                productId: 5,
                subscriptionId,
                serviceId,
                toneId
            },
        )
        return response.data
    }

    static async subscription(msisdn, subscriptionId, serviceId) {
        const response = await axios.post(`${apiConfig.depService}/upsell/subscribe`, {
                msisdn: msisdn,
                productId: 5,
                subscriptionId,
                serviceId
            },
        )
        return response.data
    }
    static async encrypt(msisdn) {
        const response = await axios.post(`${apiConfig.depService}/encrypt-msisdn/v2`, {
                msisdn: msisdn,
            },
        )
        return response.data
    }
    static async decryptMsisdn(encryptedMsisdn) {
        const response = await axios.post(`${apiConfig.depService}/decrypt-msisdn/v2`, {
            encryptedMsisdn,
            },
        )
        return response;
    }

}
